/** Framed surface shared by Verwaltung forms, filters and empty states. */
export const adminPanelClassName =
  'rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm';

/** Same frame without inner padding, for tables and divide-y lists. */
export const adminTableFrameClassName =
  'overflow-x-auto rounded-xl border border-border bg-card text-card-foreground shadow-sm';
